import request from '@/config/axios'

export interface AreaAgentLeadVO {
  id?: string
  userId?: string
  userNickname?: string
  userAvatar?: string
  realName?: string
  mobile?: string
  companyName?: string
  agentType?: number
  agentTypeName?: string
  areaIds?: string
  areaNames?: string
  remark?: string
  status?: number
  statusText?: string
  followRemark?: string
  followUserId?: string
  followTime?: string
  createTime?: string
}

export const getAreaAgentLeadPage = async (params: any) => {
  return await request.get({ url: '/trade/area-agent/lead/page', params })
}

export const getAreaAgentLead = async (id: string) => {
  return await request.get({ url: '/trade/area-agent/lead/get', params: { id } })
}

export const updateAreaAgentLeadStatus = async (data: {
  id: string
  status: number
  followRemark?: string
}) => {
  return await request.put({ url: '/trade/area-agent/lead/update-status', data })
}
